import handleInputChange from '../function/HandleInputsChange';
import { useNavigation } from '../function/navigation';
import { UnitConversion } from '../inputs/UnitConversion';

function DriveComponent({ result, inputs, setInputs, setOptions }) {
  const { nav } = useNavigation();
  const unitSystem = inputs.unit_system;

  const columns = [
    { field: 'drive', label: 'Name' },
    { field: 'speed', label: 'Speed', unit: 'm/min' },
    { field: 'power', label: 'Power [kW]' },
    { field: 'rpm', label: 'RPM' },
    { field: 'torque', label: 'Torque', unit: 'Nm' },
    { field: 'gear_ratio', label: 'Gear ratio' },
    { field: 'application_factor', label: 'Application factor' },
    { field: 'movimot_setting_range', label: 'Movimot range' },
    { field: 'stainless', label: 'Stainless steel' },
  ];

  const driveList = result.drive_list || [];

  if (driveList.length === 0 || nav.showOptions === 'priced') return null;

  if (
    driveList.length === 1 &&
    Object.keys(driveList[0]).includes('no drive')
  ) {
    return (
      <div className="low-warning-box">
        <p className="env-warning">{driveList[0]['no drive']}</p>
      </div>
    );
  }

  return (
    <div className="glass drive-table-container">
      <table>
        <thead>
          <tr>
            <th></th>
            {columns.map(({ field, label, unit }) => {
              const displayedUnit = unit
                ? UnitConversion(null, unitSystem, unit).displayedUnit
                : null;

              return (
                <th key={field}>
                  {label}
                  {displayedUnit ? ` [${displayedUnit}]` : ''}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {driveList.map((drive, index) => (
            <tr
              key={index}
              className={inputs.drive?.id === drive.id ? 'active' : ''}
              onClick={() =>
                handleInputChange('drive', drive, inputs, setInputs, setOptions)
              }
            >
              <td className="table-value">
                <input type="radio" checked={inputs.drive?.id === drive.id} />
              </td>

              {columns.map(({ field, unit }, colIndex) => {
                const rawValue = drive[field];

                if (typeof rawValue === 'boolean') {
                  return <td key={colIndex}>{rawValue ? 'true' : 'false'}</td>;
                }

                if (unit) {
                  const { displayedValue } = UnitConversion(
                    rawValue,
                    unitSystem,
                    unit
                  );

                  return (
                    <td key={colIndex}>
                      {typeof displayedValue === 'number'
                        ? Math.round(displayedValue)
                        : displayedValue}
                    </td>
                  );
                }

                return <td key={colIndex}>{rawValue}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DriveComponent;
